/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The document template data type

Values: 0=DOCX, 1=XLSX, 2=PPTX, 3=PDF
 * @export
 * @enum {number}
 */

export enum TemplateType {
    DOCX = 0,
    XLSX = 1,
    PPTX = 2,
    PDF = 3
}


